export default class Claims {
  static Failure = {
    // Hibajegyek megtekintése.
    Read: "Failure_Read",
    // Saját hibajegyek megtekintése.
    ReadOwn: "Failure_ReadOwn",
    // Hibajegyek szerkesztése.
    Write: "Failure_Write",
    // Hibajegyek megtekintése limitált adatokkal.
    ReadOwnLimited: "Failure_ReadOwnLimited",
    // Hibajegyek megtekintése call centeresnek.
    ReadCallCenter: "Failure_ReadCallCenter",
    // Hibajegyek szerkesztése call centeresnek.
    WriteCallCenter: "Failure_WriteCallCenter",
    // Hibajegyek-vállalkozó összerendelés.
    AssignToContractor: "Failure_AssignToContractor",
    // Hibajegyek-szerelő összerendelés.
    AssignToRepairman: "Failure_AssignToRepairman",
    // Hibajegy-hibajegy összerendelés.
    AttachFailure: "Failure_AttachFailure",
    // Hibajegy bejelentő adatok szerkesztése.
    ReporterWrite: "Failure_ReporterWrite",
    // Hibajegy Expanse adat szerkesztése.
    ListParam1Write: "Failure_ListParam1Write",
    // Hibajegy Nature adat szerkesztése.
    ListParam2Write: "Failure_ListParam2Write",
    // Bejelentő adatainak láthatósága hibajegy exportban
    ExportNotifierData: "Failure_ExportNotifierData",
  };

  static FailureType = {
    // Hibatípus megtekintése
    Read: "FailureType_Read",
    // Hibatípus szerkesztése
    Write: "FailureType_Write",
  };

  static ExamType = {
    // Vizsgatípusok
    Read: "ExamType_Read",
    // Vizsgák szerkesztése
    Write: "ExamType_Write",
  };

  static Exam = {
    // Vizsgák megtekintése
    Read: "Exam_Read",
    // Vizsgák szerkesztése
    Write: "Exam_Write",
  };

  static Town = {
    // Települések megtekintése
    Read: "Town_Read",
    // Saját települések megtekintése
    ReadOwn: "Town_ReadOwn",
    // Települések szerkesztése
    Write: "Town_Write",
  };

  static SpecialPlace = {
    // Speciális helyek megtekintése
    Read: "SpecialPlace_Read",
    // Speciális helyek szerkesztése
    Write: "SpecialPlace_Write",
  };

  static Inventory = {
    // Készlet megtekintése
    Read: "Inventory_Read",
    // Készlet szerkesztése
    Write: "Inventory_Write",
  };

  static Contractor = {
    // Vállalkozó megtekintése
    Read: "Contractor_Read",
    // Vállalkozó szerkesztése
    Write: "Contractor_Write",
  };

  static Device = {
    // Eszközök megtekintése
    Read: "Device_Read",
    // "Eszközök szinkronizálása
    Sync: "Device_Sync",
  };

  static ContactPerson = {
    // Kapcsolattartók megtekintése
    Read: "ContactPerson_Read",
    // Kapcsolattartók szerkesztése
    Write: "ContactPerson_Write",
  };

  static Workbook = {
    // Munkakönyv megtekintése
    Read: "Workbook_Read",
    // Munkakönyv szerkesztése
    Write: "Workbook_Write",
  };

  static Repairman = {
    // Szerelők megtekintése
    Read: "Repairman_Read",
    // Saját szerelők megtekintése
    ReadOwn: "Repairman_ReadOwn",
    // Szerelők szerkesztése
    Write: "Repairman_Write",
    // Szerelők szerkesztése
    WriteOwn: "Repairman_WriteOwn",
  };

  static Document = {
    // Dokumentumok megtekintése
    Read: "Document_Read",
    // Dokumentumok szerkesztése
    Write: "Document_Write",
  };

  static Image = {
    // Képek megtekintése
    Read: "Image_Read",
    // Képek szerkesztése
    Write: "Image_Write",
  };

  static InventoryCategory = {
    // Készlet kategóriák megtekintése
    Read: "InventoryCategory_Read",
    // Készlet kategóriák szerkesztése
    Write: "InventoryCategory_Write",
  };

  static FailureTask = {
    // Hibajegy feladat megtekintése
    Read: "FailureTask_Read",
    // Hibajegy feladat szerkesztése
    Write: "FailureTask_Write",
  };

  static Role = {
    // Szerepkörök és jogkörök megtekintése
    Read: "Role_Read",
    // Szerepkörök és jogkörök szerkesztése
    Write: "Role_Write",
  };

  static AuditLog = {
    // Régi auditlog törlés
    Delete: "AuditLog_Delete",
  };

  static Report = {
    // Riportok megtekintése
    Read: "Report_Read",
  };

  static Option = {
    // Beállítások megtekintése
    Read: "Option_Read",
    // Beállítások szerkesztése
    Write: "Option_Write",
  };

  static Maintenance = {
    // Teszt email küldési lehetőség
    TestEmail: "Maintenance_TestEmail",
  };

  static User = {
    // Felhasználók megtekintése
    Read: "User_Read",
    // Felhasználók létrehozása
    Create: "User_Create",
    // Felhasználók törlése
    Delete: "User_Delete",
    // Felhasználók meghívása
    Invite: "User_Invite",
    // Felhasználók limitált szerkesztése
    UpdateLimited: "User_UpdateLimited",
    // Felhasználók szerkesztése
    Update: "User_Update",
  };

  static MasterData = {
    // Törzsadatok megtekintése
    Read: "MasterData_Read",
  };

  static View = {
    // Törzsadatok megtekintése
    Tablet: "View_Tablet",
    // Törzsadatok megtekintése
    Desktop: "View_Desktop",
  };

  static Setting = {
    // Beállítások felület megtekintése
    Read: "Setting_Read",
  };

  static Street = {
    // "Utcák betöltése."
    Import: "Street_Import",
  };

  static FailureStatus = {
    // Hibajegy státuszok megtekintése
    Read: "FailureStatus_Read",
    // Hibajegy státuszok szerkesztése
    Write: "FailureStatus_Write",
  };
}
